import { CalendarIcon } from '@/components/svg/calendar-icon/calendar-icon'
import { ModalPositionType } from '@/context/modal-context/types'
import cx from 'classnames'
import s from './datepicker-button.module.scss'
import { useModal } from '@/hooks/use-modal'
import { format, isValid, parse } from 'date-fns'

function detectDateType(value: string): DateType {
  const now = new Date()
  const d1 = parse(value, 'dd/MM/yyyy', now)
  if (isValid(d1) && value === format(d1, 'dd/MM/yyyy')) return 'dd/MM/yyyy'

  const d2 = parse(value, 'MMMM yyyy', now)
  if (isValid(d2) && value === format(d2, 'MMMM yyyy')) return 'MMMM yyyy'

  return 'dd/MM/yyyy'
}

type DateType = 'dd/MM/yyyy' | 'MMMM yyyy'

type Props = {
  date?: string
  defaultDateType?: DateType
  placeholder?: string
  disabled?: boolean
  containerClassName?: string
  position?: ModalPositionType
  onClose?: () => void
  onConfirm?: (date: Date, type: DateType) => void
}

export const DatepickerButtonV3 = ({
  date,
  defaultDateType,
  placeholder,
  disabled,
  containerClassName,
  position,
  onClose,
  onConfirm,
}: Props) => {
  const modal = useModal()

  const openDateModal = () => {
    modal.open('datepicker', {
      ...(position && { position }),
      modalProps: {
        datePicker: {
          title: 'When is your wedding?',
          defaultDate: date,
          defaultDateType: defaultDateType || detectDateType(date || ''),
          onClose,
          onConfirm,
        },
      },
    })
  }

  return (
    <button
      type="button"
      onClick={openDateModal}
      className={cx(s.calendarButton, containerClassName)}
      disabled={disabled}
      aria-label="Open date picker"
    >
      <input
        readOnly
        value={date}
        placeholder={placeholder}
        disabled={disabled}
      />
      <span className={s.calendarIcon}>
        <CalendarIcon />
      </span>
    </button>
  )
}
